export default __webpack_public_path__ + "static/media/building.2b7538e8.jpg";